// 标签管理路由
export default {
    path: 'label',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '标签管理'},
    children: [
        {
            path: 'dictionary',
            component: () => import('@/components/RouterView'),
            redirect: '/label/dictionary/list',
            meta: { title: '标签字典'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/label/dictionary/list.vue'),
                    meta: {title: '标签字典列表'}
                },
                {
                    path: 'value/:id',
                    component: () => import('@/views/label/dictionary/value.vue'),
                    meta: {title: '值字典列表'},
                    props: true
                },
            ]
        },
        {
            path: 'enclosing',
            component: () => import('@/components/RouterView'),
            redirect: '/label/enclosing',
            meta: { title: '人群圈选'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/label/enclosing/index.vue'),
                    meta: {title: '人群圈选'}
                }
            ]
        }
    ]
};
